export default __webpack_public_path__ + "static/media/justSaved.aa1b93e5.svg";